var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toz-spinner overflow-hidden"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100%","height":"100%","viewBox":"0 0 120 120"}},[_c('circle',{attrs:{"cx":"60","cy":"60","r":"54","fill":"none","stroke":"currentColor","stroke-width":"12","stroke-dasharray":"339.292","stroke-dashoffset":"190"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }